<div class="reporting-dashboard">

  @if (initialized) {
    <div>
      <div class="chart">
        <app-bar-lines-chart [timeRange]="data.mainchart.timeRange" [bar]="data.mainchart.bars"
        [lines]="data.mainchart.lines"></app-bar-lines-chart>
      </div>
      <sc-content-spacer vertical></sc-content-spacer>
      <sc-flex [startAligned]="true">
        <app-report-table [title]="'Transporte je Transportoption'"
          [titleDictionaryKey]="data.transportsByTransportOptions.dictionaryKey" [hideHeaders]="true"
          [columns]="data.transportsByTransportOptions.columns" [rows]="data.transportsByTransportOptions.values">
        </app-report-table>
        <sc-content-spacer [double]="true"></sc-content-spacer>
        <app-report-table [columns]="data.comparison.columns" [rows]="data.comparison.values" [columnWidth]="'100px'"
        [showBorders]="true" classes="common-style"></app-report-table>
      </sc-flex>
    </div>
  }

</div>
